import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class DarkConcreteFloor extends Floor {
	static key = "DarkConcreteFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): DarkConcreteFloor {
		const f = new DarkConcreteFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
